import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Bar, Icon } from "@/shared/ui";
import { useCharactersStore } from "@/app/store/CharacterStore";
import { storeToRefs } from "pinia";


export default /*#__PURE__*/_defineComponent({
  __name: 'MentalStateBar',
  setup(__props) {

const store = useCharactersStore();

const { characters, current, maxMental } = storeToRefs(store);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Bar), {
    max: _unref(maxMental),
    current: _unref(characters)[_unref(current)].mental.current
  }, {
    icon: _withCtx(() => [
      _createVNode(_unref(Icon), { name: "MindIcon" })
    ]),
    _: 1
  }, 8, ["max", "current"]))
}
}

})